import { ClipLoader } from 'react-spinners';
import { cn } from '../../utils/classNames';
import { baseClasses, variantClasses, sizeClasses } from './primitiveClasses';

const XButton = ({
  variant = 'primary',
  size,
  type = 'button',
  className,
  disabled = false,
  onClick = () => {},
  loading = false,
  loadingText = 'Loading...',
  buttonText = 'Submit',
  children,
  ...rest
}) => (
  <button
    type={type}
    className={cn(baseClasses, variantClasses[variant], size && sizeClasses[size], className)}
    disabled={disabled || loading}
    onClick={onClick}
    {...rest}
  >
    {loading && <ClipLoader size={15} color="var(--color-white)" />}
    {loading ? ` ${loadingText}` : (children ?? buttonText)}
  </button>
);

export default XButton;
